import type { CycleType } from '@hch/shared';

/**
 * Contrats du tunnel de reservation.
 *
 * Isoles ici parce que l'orchestrateur ET les sept etapes en dependent : les
 * laisser dans l'un des fichiers de composant creerait un import circulaire.
 */

export type Step =
  'adresse' | 'cycle' | 'operation' | 'forfait' | 'creneau' | 'complements' | 'recapitulatif';

export const STEPS: Array<{ id: Step; label: string }> = [
  { id: 'adresse', label: 'Adresse' },
  { id: 'cycle', label: 'Cycle' },
  { id: 'operation', label: 'Operation' },
  { id: 'forfait', label: 'Forfait' },
  { id: 'creneau', label: 'Creneau' },
  { id: 'complements', label: 'Complements' },
  { id: 'recapitulatif', label: 'Recapitulatif' },
];

export interface BookingDraft {
  addressId?: string;
  newAddress?: {
    street: string;
    city: string;
    postalCode: string;
    country: string;
    lat: number;
    lng: number;
    isDefault: boolean;
  };
  addressLabel?: string;
  bicycleId?: string;
  newBicycle?: { brand: string; model: string; manufacturedYear: number; type: CycleType };
  bicycleLabel?: string;
  cycleType?: CycleType;
  serviceTypeId?: string;
  packageId?: string;
  slotIds?: string[];
  slotStartsAt?: string;
  slotEndsAt?: string;
  technicianName?: string;
  products: Array<{ productId: string; quantity: number }>;
  mediaKeys: string[];
  clientNotes: string;
  guest: { email: string; firstName: string; lastName: string; phone: string };
}
